import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserInfo } from 'hooks/useUserInfo';
import { Box, Typography } from '@mui/material';

interface ComplianceRouteProps {
  children: React.ReactNode;
  fallbackPath?: string;
  showAccessDenied?: boolean;
}

// Route guard for the Compliance tools (DEV-6729 alert snooze module): allows administrators and
// users with the Compliance role. Mirrors AdminRoute/RiskToolsRoute — keys off signed-in roles, so
// it is not affected by impersonation. Deliberately does NOT accept Operations, which is a much
// wider group than Compliance.
const ComplianceRoute: React.FC<ComplianceRouteProps> = ({ children, fallbackPath = '/', showAccessDenied = false }) => {
  const { isAdmin, isCompliance } = useUserInfo();

  if (!isAdmin && !isCompliance) {
    if (showAccessDenied) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px" flexDirection="column" gap={2}>
          <Typography variant="h5" color="error">
            Access Denied
          </Typography>
          <Typography variant="body1" color="text.secondary">
            You do not have the required privileges to access this page.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            This page is available to administrators and the Compliance team.
          </Typography>
        </Box>
      );
    }
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};

export default ComplianceRoute;
